/**
 * Angle conversion utilities for entity rotation handling.
 * Used by ships, projectiles, and other rotating entities.
 */

/**
 * Convert degrees to radians.
 */
export function degToRad(deg: number): number {
  return deg * (Math.PI / 180);
}

/**
 * Convert radians to degrees.
 */
export function radToDeg(rad: number): number {
  return rad * (180 / Math.PI);
}

/**
 * Wrap angle to -PI to PI range.
 * Useful for smooth rotation interpolation.
 */
export function wrapAngle(angle: number): number {
  while (angle > Math.PI) angle -= Math.PI * 2;
  while (angle < -Math.PI) angle += Math.PI * 2;
  return angle;
}
